module.exports = __webpack_public_path__ + "static/media/Excel.b19d6695.svg";